module.exports = __webpack_public_path__ + "static/img/video_daily_ADV_ok3.0b77b34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/videodaily/video_daily_ADV_ok3.jpg
// module id = pr9v
// module chunks = 1